<!--
 * @Description: 通过arkCode获取商机列表
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-03-11 10:10:29
 * @LastEditors: cxh
-->
<template>
  <a-select
    v-model:value="data"
    style="width: 100%"
    :showSearch="true"
    :filter-option="false"
    :placeholder="$t('common.pleaseSelect')"
    @change="change"
  >
    <a-select-option v-for="item in optionPage" :key="item.id" :value="item.id">
      <BusinessName :appId="appId" v-model:value="item.saleChanceName" />
    </a-select-option>
  </a-select>
</template>
<script lang="ts" setup>
import { ref, watch } from 'vue'
import type { SelectProps } from 'ant-design-vue'
import { businessList as businessListFbu } from '@/api/gucangSales/chanceManage'
import { businessList as businessListOfbu } from '@/api/overseasSales/chanceManage'
import BusinessName from '@/components/BusinessName/index.vue'
import type { PropType } from 'vue'
const props = defineProps({
  value: {
    type: [Number, String, Array]
  },
  arkCodeId: {
    // arkCode必填
    type: [Number, String]
  },
  saleChanceRefId: {
    // arkCode必填
    type: String
  },
  appId: {
    type: String,
    default: 'cos_fbu'
  },
  statusList: {
    type: Array as PropType<number[]>
  }
})
const data = ref()
const emit = defineEmits(['update:value'])
const optionPage = ref<any[]>([])
// 获取商机下拉列表
const businessListMethod = {
  cos_fbu: businessListFbu,
  cos_ofbu: businessListOfbu
}
const fetch = () => {
  if (props.arkCodeId) {
    businessListMethod[props.appId]({
      arkCodeId: props.arkCodeId,
      pageNumber: 1,
      pageSize: 500,
      statusList: props.statusList
    }).then((res: any) => {
      optionPage.value = res.data.items
    })
  }
}
// 赋值
watch(
  () => props.value,
  (v, prev) => {
    if (v !== prev && v !== data.value) {
      data.value = v
    }
  },
  { immediate: true }
)
watch(
  () => props.arkCodeId,
  (v, prev) => {
    if (v && v !== prev) {
      fetch()
      if (prev) {
        emit('update:value', undefined)
      }
    } else if (!v) {
      emit('update:value', undefined)
      optionPage.value = []
    }
  },
  { immediate: true }
)
const change: SelectProps['onChange'] = (value) => {
  emit('update:value', value)
}
</script>
